import styled from "styled-components";
import { hexToRgba } from "../HexToRGBA";

export const HoverOption = styled.div`
  display: flex;
  align-items: center;
  
padding: 2%;
  margin: 2% 0;
    text-align: center;
   width: 100%;
  padding: 14px;
  border-radius: 12px;
  font-weight: 700;
  font-size: 0.875rem;
  border: none;
  cursor: pointer;
  color: ${props => props.theme.secondaryBg};
  transition: all 0.3s ease;
  border: 0.5px solid ${(props) => props.theme.secondaryBg};

  &:hover {
    background-color: ${(props) => hexToRgba(props.theme.accentColor, 0.8)};
  }
`;

export const MenuContainer = styled.div`
display: flex;
flex-direction: column;
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;
  border-radius: 20px;
  background-color: ${props => props.theme?.mainBg};
`;

export const MenuTitle = styled.h1`
  font-size: 2.25rem;
  font-weight: 700;
  color: ${props => props.theme?.secondaryBg};
  text-align: center;
  margin-bottom: 2rem;
`;

export const MenuGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  justify-content: center;
`;

export const MenuItemButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-items: center;
  background-color: ${props => props.theme?.mainBg};
  border: 1px solid ${props => props.theme?.mainBg};
  border-radius: 1rem;
  padding: 1.5rem;
  min-height: 250px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px ${props => hexToRgba(props.theme?.secondaryBg, 0.05)};
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &:hover {
    border-color: ${props => props.theme?.secondaryColor};
    transform: translateY(-5px);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const MenuButtonIconWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => hexToRgba(props.theme?.accentColor, 0.3)};
  color: ${props => props.theme?.infoColor};
  border-radius: 50%;
  font-size: 32px;
  margin-bottom: 1rem;
`;

export const MenuIcon = styled.svg`
  color: ${props => props.theme?.infoColor};
  align-items: center;
  width: 60px;
  height: 60px;
`;
export const MenuImage = styled.div`
  color: ${props => props.theme?.infoColor};
 background: url(${props => props?.src});
  background-size: cover;
  background-position: center;
  align-items: center;
  width: 60px;
  height: 60px;
`;

export const MenuButtonContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const MenuButtonTitle = styled.p`
  font-size: 1.125rem;
  font-weight: 600;
  color: ${props => props.theme?.secondaryBg};
  margin-bottom: 0.5rem;
`;

export const MenuButtonDescription = styled.p`
  font-size: 0.875rem;
  color: ${props => props.theme?.accentColor};;
  line-height: 1.5;
`;
